import { h } from 'vue';
import { PARAGRAPH_RENDERED_NODE_NAME } from './constant.js';

const paragraphRenderElement = ({
  children,
  attributes
}) => {
  return h(
    PARAGRAPH_RENDERED_NODE_NAME,
    {
      ...attributes,
      class: "se-paragraph"
    },
    children
  );
};

export { paragraphRenderElement };
//# sourceMappingURL=render-element.js.map
